const FALLBACK_HCELL_ENGINE_URL = 'https://172.19.0.129:9022/';

const rawEnvUrl = import.meta.env?.VITE_HCELL_ENGINE_URL as string | undefined;
const sanitizedUrl =
  typeof rawEnvUrl === 'string' && rawEnvUrl.trim().length > 0
    ? rawEnvUrl.trim()
    : FALLBACK_HCELL_ENGINE_URL;

let hcellEngineOrigin = 'https://172.19.0.129:9022';
try {
  hcellEngineOrigin = new URL(sanitizedUrl).origin;
} catch {
  hcellEngineOrigin = new URL(FALLBACK_HCELL_ENGINE_URL).origin;
}

export const HCELL_ENGINE_URL = sanitizedUrl;
export const HCELL_ENGINE_ORIGIN = hcellEngineOrigin;
export const DEFAULT_HCELL_ENGINE_URL = FALLBACK_HCELL_ENGINE_URL;
